import { TFunction } from 'react-i18next';
import * as yup from 'yup';

export const pipelineFormSchema = (t: TFunction<'translation', undefined>) =>
    yup.object().shape({
        title: yup.string().required(t('@validations.field.isRequired', { field: t('@common.title') })),
        alias: yup.string().required(t('@validations.field.isRequired', { field: t('@alias') })),
    });
